import {Component, Input} from '@angular/core';

export class BreadCrumbItem {
  label: string;
  route?: any[] | string;
  icon?: string;
}

@Component({
  selector: 'app-page-header',
  template:
  `<div class="alain-default__content-title">
    <nz-breadcrumb *ngIf="breabcrumb">
      <nz-breadcrumb-item *ngFor="let item of breabcrumb">
        <a [routerLink]="item.route" *ngIf="item.route">
          <i nz-icon [type]="item.icon" *ngIf="item.icon"></i>
          {{item.label | translate}}
        </a>
        <span *ngIf="!item.route">
          <i nz-icon [type]="item.icon" *ngIf="item.icon"></i>
          {{item.label | translate}}
        </span>
      </nz-breadcrumb-item>
    </nz-breadcrumb>
    <h1 *ngIf="title" [translate]="title" style="font-weight: 500;"></h1>
  </div>`
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() breabcrumb: BreadCrumbItem[];
}
